/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Pace_Est_Race_Time_ShortInputs */

const en_ui_pace_est_race_time_short = /** @type {(inputs: Ui_Pace_Est_Race_Time_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Race Time`)
};

const de_ui_pace_est_race_time_short = /** @type {(inputs: Ui_Pace_Est_Race_Time_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wettkampfzeit`)
};

/**
* | output |
* | --- |
* | "Race Time" |
*
* @param {Ui_Pace_Est_Race_Time_ShortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_pace_est_race_time_short = /** @type {((inputs?: Ui_Pace_Est_Race_Time_ShortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Pace_Est_Race_Time_ShortInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_pace_est_race_time_short(inputs)
	return de_ui_pace_est_race_time_short(inputs)
});